import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import { motion } from 'framer-motion';
import { ShoppingBag, TrendingUp, Truck, Shield } from 'lucide-react';

const MerchPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Official Merchandise | CryptoIndia';
  }, []);

  const products = [
    {
      id: 'evolution-money',
      name: 'Evolution of Money T-Shirt',
      price: '₹999',
      image: 'https://kadakmerch.com/cdn/shop/products/T1_6d387557-26e8-47dc-87b0-59d8c2320847_2048x2048.jpg',
      link: 'https://kadakmerch.com/collections/cryptoindia/products/evolution-of-money-t-shirt'
    },
    {
      id: 'bitcoin-hodler',
      name: 'Bitcoin Dheet Hodler T-Shirt',
      price: '₹999',
      image: 'https://kadakmerch.com/cdn/shop/products/T2_d898a654-f26e-4bef-87e7-cce6f9bc74e1_2048x2048.jpg',
      link: 'https://kadakmerch.com/collections/cryptoindia/products/bitcoin-dheet-hodler-t-shirt'
    }
  ];

  const features = [
    {
      icon: <ShoppingBag className="w-6 h-6 text-yellow-400" />,
      title: 'Premium Quality',
      description: 'High-quality materials and printing for long-lasting comfort'
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-yellow-400" />,
      title: 'Limited Edition',
      description: 'Exclusive designs available for a limited time only'
    },
    {
      icon: <Truck className="w-6 h-6 text-yellow-400" />,
      title: 'Fast Shipping',
      description: 'Quick delivery across India with secure packaging'
    },
    {
      icon: <Shield className="w-6 h-6 text-yellow-400" />,
      title: 'Secure Payment',
      description: 'Safe and secure payment options available'
    }
  ];

  return (
    <div className="bg-black">
      <Hero 
        title="Official CryptoIndia Merch"
        subtitle="Show your crypto pride with our exclusive collection of high-quality merchandise"
        ctaText="Shop Now"
        config={{
          image: "https://images.pexels.com/photos/7567455/pexels-photo-7567455.jpeg",
          overlayOpacity: 0.8,
          position: "center"
        }}
      />

      {/* Features */}
      <section className="py-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-zinc-900 rounded-xl p-6 border border-zinc-800">
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-400/10 p-3 rounded-lg">
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 bg-zinc-900">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Featured Products</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Browse our collection of premium crypto-themed merchandise
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {products.map((product) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-black rounded-xl overflow-hidden border border-zinc-800 hover:border-yellow-400 transition-all duration-300"
              >
                <a 
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <div className="aspect-square relative overflow-hidden bg-zinc-900">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-110"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                    <p className="text-yellow-400 text-lg font-semibold">{product.price}</p>
                    <button className="mt-4 w-full btn bg-yellow-400 hover:bg-yellow-500 text-black">
                      Buy Now
                    </button>
                  </div>
                </a>
              </motion.div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a 
              href="https://kadakmerch.com/collections/cryptoindia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn bg-yellow-400 hover:bg-yellow-500 text-black inline-flex items-center"
            >
              View All Products
              <ShoppingBag className="ml-2 w-4 h-4" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MerchPage;